<template>
  <div class="infoForm" v-loading="loading">
    <div class="statusDiv" v-if="(isEdit || readOnly) && !isMerchant">
      <span :class="statusColor" class="status"><i class="el-icon-warning-outline"></i>{{ form.statusDesc }}</span>
      <!--              审核失败时，显示原因-->
      <span class="reviewTime" v-if="form.statusDesc === '审核不通过'">退回原因：{{ remark }}</span>
    </div>
    <el-tabs v-model="activeTab" @tab-click="handleClick">
      <el-tab-pane name="basic" :disabled="!readOnly && currentTabIndex < orderTabs.indexOf('basic')">
        <span slot="label"><span class="required">*</span> 商户基本信息</span>
      </el-tab-pane>
      <el-tab-pane name="business" :disabled="!readOnly && currentTabIndex < orderTabs.indexOf('business')">
        <span slot="label"><span class="required">*</span> 商户营业信息</span>
      </el-tab-pane>
      <el-tab-pane name="settle" :disabled="!readOnly && currentTabIndex < orderTabs.indexOf('settle')">
        <span slot="label"><span class="required">*</span> 结算信息</span>
      </el-tab-pane>
      <el-tab-pane label="辅助信息" name="assist" :disabled="!readOnly && currentTabIndex < orderTabs.indexOf('assist')">
      </el-tab-pane>
    </el-tabs>
    <el-form label-width="120px" ref="basicForm" :model="form" :rules="rule_data" v-show="currentTabIndex === orderTabs.indexOf('basic')" label-position="left">
      <basic-info ref="basicInfo"/>
    </el-form>
    <el-form label-width="120px" ref="businessForm" :model="businessForm" :rules="rule_data" v-show="currentTabIndex === orderTabs.indexOf('business')" :disabled="readOnly" label-position="left">
      <business-info ref="businessInfo"/>
    </el-form>
    <el-form label-width="120px" ref="settleForm" :model="settleForm" :rules="rule_data" v-show="currentTabIndex === orderTabs.indexOf('settle')" :disabled="readOnly" label-position="left">
      <settle-info ref="settleInfo"></settle-info>
    </el-form>
    <el-form label-width="120px" ref="assistForm" :model="form" :rules="rule_data" v-show="currentTabIndex === orderTabs.indexOf('assist')" :disabled="readOnly" label-position="left">
      <assist-info ref="assistInfo"></assist-info>
    </el-form>
    <div class="flex-center" v-show="!readOnly">
      <el-button @click="lastStep" v-show="currentTabIndex > 0">上一页</el-button>
      <el-button
        type="primary"
        :loading="nextLoading"
        @click="nextStep"
        v-show="currentTabIndex < orderTabs.length - 1"
      >保存，进入下一页</el-button>
      <el-button
        type="primary"
        :loading="submitLoading"
        @click="nextStep"
        v-show="currentTabIndex === orderTabs.length - 1"
      >提交审核</el-button>
    </div>
  </div>
</template>

<script>
import qs from 'qs'
// import luhmCheck from '@/utils/luhmCheck.js'
import { hideBankCardNum, hideRealName, hidePhoneNum, hideIdCardNum } from '@/utils/hideSensitiveInfo.js'
import { findBranch } from '@/api/global'
import { getMerchantInfo } from '@/api/merchant'
import { validSimplePsd, simplePsdError } from '@/utils/validate.js'
import basicInfo from './basicInfo'
import businessInfo from './businessInfo'
import settleInfo from './settleInfo'
import assistInfo from './assistInfo'

export default {
  name: 'InfoForm',
  components: {
    basicInfo,
    businessInfo,
    settleInfo,
    assistInfo
  },
  props: {
    // 整个表单能否编辑，区分是否是查看页面
    readOnly: {
      type: Boolean,
      default: false
    },
    // 商户id
    id: {
      type: String,
      default: ''
    },
    // 是否是编辑页面，用来控制一些编辑时不可编辑项，例如店铺类型等
    isEdit: {
      type: Boolean,
      default: false
    },
    submitText: {
      type: String,
      default: '提交审核'
    },
    submitLoading: {
      type: Boolean,
      default: false
    },
    // 是否是商户版-商户信息
    isMerchant: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false, // 初始化加载
      headShopMerchantIdInput: false, // 是否显示总店商户编号输入框
      headShopMerchantIdOld: '', // 保存原本的总店商户id
      headShopMerchantIdError: '', // 总店编号错误信息
      userNameItemError: '', // 登录账号错误信息
      checkLoading: false, // 登录账号校验加载
      selectLoading: true,
      agentChannelList: [], // 渠道商列表

      // 企业资料选择总店，信息回填
      form: {
        // 商户基本信息
        fNopassReason: '', // 退回原因
        shopType: 1, // 店铺类型
        chainType: 0,
        merchantAppSource: 0,
        headMerchantId: '', // 总店商户编号
        username: '', // 登录账号
        password: '', // 登录密码
        mobile: '', // 绑定手机
        notifyAddress: '', // 交易异步回调（通知）地址URL
        statusDesc: '', // 状态文本
        statusId: '', // 状态id
        // 其他设置
        reportConfigId: '', // 渠道商名称
        subscribeAppid: '', // 关注APPID
        subAppid: '', // 支付APPID
        auditCallback: '', // 商户审核回调
        remark: '', // 退回原因
        businessInfoFlag: 0, // 企业资料0分店1总店
        merchantShortName: '', // 商户简称
        merchantType: '', // 商户类型
        companyChildType: '',
        realMerchantType: '',
        mccType: '', // 行业大类
        mccMiddle: '', // 行业小类
        mccCode: '', // 行业详细类
        servicePhone: '' // 客服电话
      },
      // 商户入网信息
      businessForm: {
        merchantName: '', // 商户全称
        licensePic: '', // 营业执照照片
        licenseFullName: '', // 营业执照名称
        license: '', // 营业执照号
        licenseStart: '', // 营业执照有效期
        licenseEnd: '',
        licenseFlag: false, // 是否有营业执照号
        legalName: '', // 法人姓名
        idCardNo: '', // 法人证件号
        idCardStart: '', // 证件有效期
        idCardEnd: '',
        credentialType: 1, // 法人证件类型
        provinceCode: '', // 经营地址省
        cityCode: '', // 经营地址市
        areaCode: '', // 经营地址区
        address: '', // 经营地址详细

        idcardFrontPic: '', // 法人证件照正面
        idcardBackPic: '', // 法人证件照背面

        licenseType: 0, // 企业证件类型
        businessEditable: false // 入网信息是否可编辑，总店不可编辑
      },
      //    结算信息
      settleForm: {
        settleTo: '', // 结算对象
        accountType: '', // 账户类型，1对私账户，2对公账户
        legalFlag: '', // 结算类型，0非法人，1法人
        holder: '', // 开户名
        bankCardNo: '', // 开户号
        bankIdCardType: 1, // 开户人证件类型
        accountIdCardNo: '', // 开户人证件
        FBankTypeCode: '', // 银行类型编码
        FBankAreaCode: '', // 银行网点省编码
        FBankCityCode: '', // 银行网点市编码
        unionpay: '', // 分行网点id
        accountMobile: '', // 预留号码
        nonLegSettleAuthPic: '', // 非法人授权书
        nonLegIdcardFrontPic: '', // 非法人身份证人像面
        nonLegIdcardBackPic: '', // 非法人身份证国徽面
        bankCardFrontPic: ''// 银行卡照片/开户许可证
      },

      picForm: {
        insidePic: '',
        doorPic: '',
        cashierDeskPic: '',
        agreementPic: '',
        otherPics: '',
        otherPicsPath: ''
      },
      parentData: {
        basic: {},
        pic: {}
      }, // 进件加盟分店时，记录总店数据
      ifHide: false, // 是否隐藏部分信息
      licenseExpiryDate: {
        dateStart: '',
        dateEnd: '',
        longTermTag: false,
        valueName: 'license'
      }, // 营业执照有效期
      idCardExpiryDate: {
        dateStart: '',
        dateEnd: '',
        longTermTag: false,
        valueName: 'idCard'
      }, // 证件有效期
      // accountTypeLabel:'银行卡照片',
      needOcr: true, // 是否需要OCR查询
      remark: false, // 审核退回原因
      activeTab: 'basic', // 标签名
      currentTabIndex: 0, // 当前标签页
      orderTabs: ['basic', 'business', 'settle', 'assist'],
      needMcc: false, // 提供子组件监听异步函数完成字段
      rule_data: {
        username: [
          { required: true, message: '请输入登录账号', trigger: 'blur' }
        ],
        password: [{
          validator: (rule, value, callback) => {
            if (validSimplePsd(value)) {
              callback()
            } else {
              return callback(new Error(simplePsdError))
            }
          },
          trigger: 'blur',
          required: true
        }],
        mobile: [{
          validator: (rule, value, callback) => {
            // eslint-disable-next-line no-mixed-operators
            if (!(/^\d{11,11}$/.test(value)) && (!value.includes('*') && this.isEdit || !this.isEdit)) {
              callback(new Error('请输入11位手机号码'))
            } else {
              callback()
            }
          },
          required: true,
          trigger: 'blur'
        }],
        merchantShortName: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入商户简称'))
            } else {
              if (!(/^\S*$/.test(value))) {
                callback(new Error('空格无效，请重新输入'))
              } else if (/(?!^\w+$)^.{2,30}$/.test(value) || /[a-zA-Z]{2,30}$/.test(value)) {
                callback()
              } else {
                callback(new Error('商户简称为长度2~30的汉字英文或汉字英文与数字组合'))
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        servicePhone: [{
          validator: (rule, value, callback) => {
            if (value.includes('-')) {
              callback(new Error('客服电话中不能带-'))
            } else if (!(/^\d{5,20}$/.test(value)) && value !== '' && !value.includes('*')) {
              callback(new Error('请输入正确的客服电话'))
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }],
        merchantInfo: [{
          validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error('请选择店铺类型'))
            } else {
              callback()
            }
          },
          trigger: 'change',
          required: true
        }],
        realMerchantType: [{
          validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error('请选择商户类型'))
            } else {
              callback()
            }
          },
          trigger: 'change',
          required: true
        }],
        merchantName: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入商户全称'))
            } else {
              if (!(/^\S*$/.test(value))) {
                callback(new Error('空格无效，请重新输入'))
              } else if (/(?![^\u4E00-\u9FA5]+$)^.{2,40}$/.test(value)) {
                callback()
              } else {
                callback(new Error('商户全称为长度2~40的汉字或汉字与数字组合'))
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        legalName: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入正确姓名'))
            } else {
              if (!(/^\S*$/.test(value)) && this.businessForm.credentialType !== 6) {
                callback(new Error('空格无效，请重新输入'))
              } else if (value.length >= 2 && value.length <= 45) {
                callback()
              } else {
                callback(new Error('请输入2~45位法人姓名'))
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        idCardNo: [{
          validator: (rule, value, callback) => {
            const credentialType = this.businessForm.credentialType
            if (value === '') {
              callback(new Error('请输入法人证件号码'))
            } else {
              if (credentialType === 2) {
                // eslint-disable-next-line no-useless-escape
                if (!((/^[HM]{1}([\d|\*]{10}|[\d|\*]{8})$/.test(value)) || (/^([\d|\*]{8}|[\d|\*]{10})$/.test(value)))) {
                  callback(new Error('通行证号码输入有误'))
                } else {
                  callback()
                }
              } else if (credentialType === 1) {
                // eslint-disable-next-line no-useless-escape
                if (!(/(^[\d|\*]{15}$)|(^[\d|\*]{18}$)|(^[\d|\*]{17}(\d|X|x)$)/.test(value))) {
                  callback(new Error('请输入15/18位身份证号'))
                } else {
                  callback()
                }
              } else {
                callback()
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        // 以下是证照信息校验
        idcardFrontPic: [{
          required: true,
          message: '请上传法人证件照头像面',
          trigger: 'change'
        }],
        idcardBackPic: [{
          required: true,
          message: '请上传法人证件照国徽面',
          trigger: 'change'
        }],
        license: [{
          validator: (rule, value, callback) => {
            if (this.businessForm.licenseFlag || this.form.businessInfoFlag) {
              callback()
            } else if ((value === '' || value === undefined)) {
              callback(new Error('请输入营业执照号'))
            } else {
              if (this.businessForm.licenseType === 0 && !(/(^[A-Za-z\d]{15}$)|(^[A-Za-z\d]{18}$)/.test(value))) {
                callback(new Error('请输入15/18位营业执照号'))
              } else {
                callback()
              }
            }
          },
          trigger: 'blur'
        }],
        licensePic: [{
          validator: (rule, value, callback) => {
            if (!this.businessForm.licenseFlag && (value === '' || value === undefined)) {
              callback(new Error('请上传营业执照'))
            } else {
              callback()
            }
          },
          trigger: 'change'
        }],
        settleTo: [{
          required: true,
          message: '请选择结算对象',
          trigger: 'change'
        }],
        chainType: [{
          required: true,
          message: '请选择是否连锁总部',
          trigger: 'change'
        }],
        merchantAppSource: [{
          required: true
        }],
        accountType: [{
          required: true,
          message: '请选择账户类型',
          trigger: 'change'
        }],
        legalFlag: [{
          required: true,
          message: '请选择结算类型',
          trigger: 'change'
        }],
        holder: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入正确的开户名'))
            } else {
              if (!(/^\S*$/.test(value)) && this.settleForm.bankIdCardType !== 6) {
                callback(new Error('空格无效，请重新输入'))
              } else if (value.length >= 2 && value.length <= 45) {
                callback()
              } else {
                callback(new Error('请输入2~45位开户名'))
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        bankCardNo: [{
          validator: (rule, value, callback) => {
            if (this.settleForm.settleTo) {
              callback()
              return
            }
            if (value === '') {
              callback(new Error(`${this.settleForm.accountType === 2 ? '请输入正确的开户许可证账号' : '请输入正确的个人银行卡号'}`))
            } else {
              callback()
            }
            // else {
            //   if ((this.settleForm.accountType === 2 && /^\S{5,30}$/.test(value)) || (this.isEdit && value.includes('*'))) {
            //     callback()
            //     // } else if (this.settleForm.accountType !== 2 && /^\d{16,19}$/.test(value) && luhmCheck(this.settleForm.bankCardNo) || this.isEdit && value.includes('*')) {
            //   } else if ((this.settleForm.accountType !== 2 && /^\d{16,19}$/.test(value)) || (this.isEdit && value.includes('*'))) {
            //     callback()
            //   } else {
            //     callback(new Error(`${this.settleForm.accountType === 2 ? '请输入正确的开户许可证账号' : '请输入正确的个人银行卡号'}`))
            //   }
            // }
          },
          required: true,
          trigger: 'blur'
        }],
        accountIdCardNo: [{
          validator: (rule, value, callback) => {
            if (value === '' && this.settleForm.accountType !== 2) {
              callback(new Error('请输入开户人证件号'))
            } else if (this.settleForm.accountType !== 2) {
              // eslint-disable-next-line no-useless-escape
              if (!(/(^[\d|\*]{15}$)|(^[\d|\*]{18}$)|(^[\d|\*]{17}(\d|X|x)$)/.test(value)) && this.settleForm.bankIdCardType === 1) {
                callback(new Error('请输入15/18位身份证号'))
              // eslint-disable-next-line no-useless-escape
              } else if (!((/^[HM]{1}([\d|\*]{10}|[\d|\*]{8})$/.test(value)) || (/^([\d|\*]{8}|[\d|\*]{10})$/.test(value))) && this.settleForm.bankIdCardType === 2) {
                callback(new Error('通行证号码输入有误'))
              } else {
                callback()
              }
            } else {
              callback()
            }
          },
          required: true,
          trigger: 'blur'
        }],
        accountMobile: [{
          required: false,
          validator: (rule, value, callback) => {
            if (!value) {
              callback()
            } else {
              const check = (/^(\d{3,4}-?)?\d{7,9}$/.test(value) || /^(((13[0-9]{1})|(15[0-9]{1})|(14[0-9]{1})|(17[0-9]{1})|(18[0-9]{1})|(16[0-9]{1})|(19[0-9]{1}))+\d{8})$/.test(value) || value.includes('*'))
              if (!check && !this.settleForm.settleTo && !this.readOnly) {
                callback(new Error('请输入正确手机号或座机号'))
              } else {
                callback()
              }
            }
          },
          message: '请输入正确手机号或座机号',
          trigger: 'blur'
        }],
        bankCardFrontPic: [{
          validator: (rule, value, callback) => {
            if (value === '' || value === undefined) {
              callback(new Error(this.settleForm.accountType !== 2 ? '请上传银行卡正面' : '请上传开户许可证'))
            } else {
              callback()
            }
          },
          trigger: 'change',
          required: true
        }],
        nonLegSettleAuthPic: [{
          validator: (rule, value, callback) => {
            if (this.settleForm.legalFlag === 0 && (value === '' || value === undefined)) {
              callback(new Error('请上传非法人结算授权协议'))
            } else {
              callback()
            }
          },
          trigger: 'change'
        }],
        nonLegIdcardFrontPic: [{
          validator: (rule, value, callback) => {
            if (this.settleForm.legalFlag === 0 && (value === '' || value === undefined)) {
              callback(new Error('请上传非法人身份证头像面'))
            } else {
              callback()
            }
          },
          trigger: 'change'
        }],
        nonLegIdcardBackPic: [{
          validator: (rule, value, callback) => {
            if (this.settleForm.legalFlag === 0 && (value === '' || value === undefined)) {
              callback(new Error('请上传非法人身份证国徽面'))
            } else {
              callback()
            }
          },
          trigger: 'change'
        }],
        notifyAddress: [{ pattern: /^\S*$/, message: '空格无效，请重新输入', trigger: 'blur' }],
        auditCallback: [{ pattern: /^\S*$/, message: '空格无效，请重新输入', trigger: 'blur' }]
      },
      isUpgrade: false,
      canUpgrade: false
    }
  },
  computed: {
    statusColor () {
      const state = this.form.statusId
      let color
      switch (state) {
        case 1: {
          color = 'red'
          break
        }
        case 3: {
          color = 'green'
          break
        }
        default: {
          color = 'gray'
        }
      }
      return color
    }
  },
  mounted () {
    // 不是编辑页面、小微商户升级且不是查看，触发本地存储
    if (!this.isEdit && !this.readOnly) {
      // 读取本地存储数据
      this.getLocalStorageAddInfo()
      this.setStoreOnEvent()
    } else {
      this.getDetailsInfo()
    }
  },
  watch: {
    'settleForm.legalFlag': function (val, oldVal) {
      if (!this.readOnly && this.needOcr && !this.loading) {
        this.settleForm.nonLegSettleAuthPic = ''
        this.settleForm.nonLegIdcardFrontPic = ''
        this.settleForm.nonLegIdcardBackPic = ''
        if (val === 1) {
          this.settleForm.holder = this.businessForm.legalName
          this.settleForm.bankIdCardType = this.businessForm.credentialType
          this.settleForm.accountIdCardNo = this.businessForm.idCardNo
        } else {
          if (this.settleForm.settleTo === 1) {
            this.settleToMethod(1)
          } else {
            this.settleForm.holder = ''
            this.settleForm.bankIdCardType = 1
            this.settleForm.accountIdCardNo = ''
          }
        }
      }
    },
    'businessForm.legalName': function (val) {
      if (this.settleForm.accountType === 1 && this.settleForm.legalFlag === 1 && !this.loading) {
        this.settleForm.holder = val
      }
    },
    'businessForm.credentialType': function (val) {
      if (this.settleForm.accountType === 1 && this.settleForm.legalFlag === 1 && !this.loading) {
        this.settleForm.bankIdCardType = val
      }
    },
    'businessForm.idCardNo': function (val) {
      if (this.settleForm.accountType === 1 && this.settleForm.legalFlag === 1 && !this.loading) {
        this.settleForm.accountIdCardNo = val
      }
    }
  },
  activated () {
    this.$nextTick(() => {
      if (this.id !== '') {
        this.getDetailsInfo()
      }
    })
  },
  methods: {
    /**
             * @description 企业资料切换联动，选择总店时，查询使用总店的信息，否则清空数据
             * @param {Number} value 0分店，1总店
             */
    businessInfoMethod (value) {
      const that = this
      // 企业资料选择的是总店
      this.form.merchantType = ''
      this.form.realMerchantType = ''
      this.form.merchantShortName = ''
      this.form.mccCode = ''
      this.form.mccMiddle = ''
      this.form.mccType = ''
      this.form.servicePhone = ''
      that.form.businessInfoFlag = 0
      if (value === 1) {
        that.form.businessInfoFlag = 1
        that.$refs.businessForm.resetFields()
        // 如果总店编号能查询到数据
        if (JSON.stringify(this.parentData) !== JSON.stringify(this.$options.data().parentData)) {
          const basic = this.parentData.basic
          const pic = this.parentData.pics
          this.setBusinessForm(basic, pic)
        } else {
          this.businessInfoMethod(0)
          this.form.businessInfoFlag = 0
          that.$message({
            message: '总店商户不存在或信息获取失败，请核对并重试！',
            type: 'error'
          })
        }
      } else {
        // 入网信息表单恢复到初始值
        that.$refs.businessForm.resetFields()
        that.$refs.businessInfo.$refs.licenseExpiryDate.$refs.form.resetFields()
        that.$refs.businessInfo.$refs.addressSelectForm.$refs.form.resetFields()
        that.$refs.businessInfo.$refs.idCardExpiryDate.$refs.form.resetFields()
        // 如果企业资料是分店，而结算类型是总店，只能是非法人结算，需上传非法人图片
        if (that.settleForm.settleTo === 1) {
          that.settleForm.legalFlag = 0
        }
      }
      this.$nextTick(() => { that.$refs.basicForm.clearValidate() })
    },
    /**
             * @description 法人证件类型切换，法人证件号和图片都要置空
             * @param {Number} type 1身份证，2港澳通行证
             */
    swiftCertType (type) {
      if (type === 1) {
        this.credentialLabel.idCardHolder = '请输入15/18位身份证号码'
      } else if (type === 2) {
        this.merchantExcelName = ''
        this.credentialLabel.idCardHolder = '请输入HM开头加8或10位数字的通行证号码'
      } else {
        this.credentialLabel.idCardHolder = '请输入法人证件号码'
      }
      this.businessForm.idCardNo = ''
      this.businessForm.idcardFrontPic = ''
      this.businessForm.idcardBackPic = ''
      this.$refs.businessForm.clearValidate('idCardNo')
      if (this.settleForm.legalFlag === 1) {
        this.settleForm.bankIdCardType = this.businessForm.credentialType
      } else {
        this.settleForm.bankIdCardType = 1
      }
    },
    /**
     * @description 请求总店的数据，如果企业资料和结算信息选择总店就可以直接回填
     */
    getParentData () {
      const that = this
      let param = {
        merchantId: that.form.headMerchantId
      }
      this.loading = true
      param = qs.stringify(param)
      getMerchantInfo(param).then(data => {
        this.loading = false
        if (data.result_cde === '0') {
          that.parentData = data
          // this.getGroup(that.parentData.basic.fMccType);
        } else {
          that.$message({
            message: data.result_msg,
            type: 'error'
          })
        }
      })
    },
    /**
             * @description 读取本地存储数据方法
             */
    async getLocalStorageAddInfo () {
      const addInfo = {
        form: { ...this.$options.data().form },
        businessForm: { ...this.$options.data().businessForm },
        settleForm: { ...this.$options.data().settleForm },
        picForm: { ...this.$options.data().picForm },
        parentData: { ...this.$options.data().parentData },
        licenseExpiryDate: { ...this.$options.data().licenseExpiryDate },
        idCardExpiryDate: { ...this.$options.data().idCardExpiryDate }
      }
      addInfo.form.password = ''
      const defaultAddInfo = JSON.stringify(addInfo)
      const storageAddInfo = localStorage.getItem('MERCHANT_ADD_INFO2')
      // 和初始值进行比较
      if (storageAddInfo && storageAddInfo !== 'undefined' && storageAddInfo !== defaultAddInfo) {
        await this.$confirm('是否要读取已保存表单数据？', '提示', {
          confirmButtonText: '读取',
          cancelButtonText: '不读取',
          closeOnClickModal: false
        }).then(() => {
          const storageAddInfoObj = JSON.parse(storageAddInfo)
          for (const key in storageAddInfoObj) {
            // eslint-disable-next-line no-prototype-builtins
            if (storageAddInfoObj.hasOwnProperty(key) && typeof storageAddInfoObj[key] === 'object') {
              for (const childKey in storageAddInfoObj[key]) {
                // eslint-disable-next-line no-prototype-builtins
                if (storageAddInfoObj[key].hasOwnProperty(childKey)) {
                  this[key][childKey] = storageAddInfoObj[key][childKey]
                }
              }
            }
          }
          this.needOcr = false
        }).catch(() => {

        })
        this.needOcr = true
        this.needMcc = true
      }
    },
    /**
             * @description 表单校验，提交给父级
             */
    async submit () {
      if (this.form.merchantType !== 3 && this.businessForm.merchantName.includes('公司')) {
        this.$message({
          message: '商户全称包含“公司”，商户类型请选择企业',
          type: 'warning'
        })
        return
      }
      let picArr = []
      if (this.picForm.otherPics) {
        picArr = this.picForm.otherPics.split(',')
      }
      const picData = {}
      picArr.map((value, index) => {
        picData[`pic${index + 1}`] = value
        return value
      })
      const data = Object.assign({ isUpgrade: this.isUpgrade ? 1 : 0 }, this.form, this.businessForm, this.settleForm, this.otherForm, this.picForm, this.beneficiaryForm)
      data.otherPics = JSON.stringify(picData)
      if (this.bankTypeError) {
        await this.$confirm('卡号与开户行不匹配，是否确认提交？', '提示', {}).then(() => {
        })
      }
      this.$emit('submit', data)
    },
    /**
             * @description 查看或编辑时获取初始信息
             */
    getDetailsInfo () {
      let data = {
        merchantId: this.id
      }
      const that = this
      data = qs.stringify(data)
      this.loading = true
      getMerchantInfo(data).then(data => {
        this.needOcr = false
        this.refresh = false
        if (parseInt(data.result_cde) !== 0) {
          this.$message({
            showClose: true,
            message: data.result_msg,
            type: 'error'
          })
        } else {
          const basic = data.basic
          const pic = data.pics
          const otherPicArr = []
          const otherPicArrPath = []
          if (basic.statusDesc === '审核通过' || basic.statusDesc === '待审核') {
            this.ifHide = true
          } else {
            this.ifHide = false
          }
          // registerState: -2:商户不存在-1:待完善资料，0：待审核，1：审核失败，2：人工审核，3：审核成功
          this.canUpgrade = basic.fMerchantType === 1 && basic.registerState === 3 && this.isEdit
          this.form.shopType = basic.shopType
          this.form.fNopassReason = basic.fNopassReason || ''
          this.form.headMerchantId = basic.headShopMerchantId || ''
          this.form.username = basic.fUserName || ''
          this.form.mobile = this.ifHide ? hidePhoneNum(basic.fMobile) : basic.fMobile || ''
          this.form.notifyAddress = basic.notifyAddress || ''

          this.form.reportConfigId = basic.reportConfigId || ''
          this.form.subscribeAppid = basic.subscribeAppid || ''
          this.form.subAppid = basic.subAppid || ''
          this.form.auditCallback = basic.auditCallback || ''
          this.form.merchantAppSource = basic.merchantAppSource || 0

          this.form.chainType = basic.chainType

          this.setBusinessForm(basic, pic)
          this.settleForm.settleTo = basic.settleTo

          this.setSettleForm(basic, pic)
          // 赋值受益人信息

          this.form.statusDesc = basic.statusDesc || ''
          this.form.statusId = basic.state || ''

          if (![-1, 3, 1].includes(this.form.statusId)) {
            this.$emit('resetDisabled', true)
          }

          if (this.form.statusDesc === '审核不通过') {
            this.remark = basic.failReason || ''
          }
          for (let i = 1; i <= 20; i++) {
            pic[`pic${i}Url`] && otherPicArr.push(pic[`pic${i}Url`])
            pic[`pic${i}`] && otherPicArrPath.push(pic[`pic${i}`])
          }
          this.picForm.otherPics = otherPicArr.join(',')
          this.picForm.otherPicsPath = otherPicArrPath.join(',')
          //    位置变化的属性赋值
          if (this.isEdit) {
            this.picForm.insidePic = pic.businessInsideUrl || ''
            this.picForm.doorPic = pic.doorPhotoUrl || ''
            this.picForm.cashierDeskPic = pic.cashierDeskUrl || ''
            this.picForm.agreementPic = pic.agreementPicUrl || ''
            this.picForm.video = pic.video || ''
          } else {
            this.picForm.insidePic = pic.businessInside || ''
            this.picForm.doorPic = pic.doorPhoto || ''
            this.picForm.cashierDeskPic = pic.cashierDesk || ''
            this.picForm.agreementPic = pic.agreementPic || ''
            this.picForm.video = pic.video || ''
          }
          // 编辑商户且为分店
          if (this.isEdit && this.form.headMerchantId) {
            // this.getParentData()
          }
          this.form.contactPhoneNo = basic.contactPhoneNo
          this.form.contactIdCard = basic.contactIdCard
          this.form.contactName = basic.contactName
        }
        this.$nextTick(function () {
          that.needOcr = true
          that.loading = false
        })
      })
    },
    // 根据联行号查出银行信息
    getInfoByUnion (code) {
      const that = this
      const data = qs.stringify({
        unionpayCode: code
      })
      findBranch(data).then(response => {
        if (parseInt(response.result_cde) === 0) {
          const data = response.data
          this.settleForm.FBankTypeCode = data.finInstitutionCode
          this.settleForm.FBankAreaCode = data.cftAreaCode
          this.settleForm.FBankCityCode = data.cftCityCode
          this.settleForm.unionpay = data.unionpayCode
        } else {
          that.$message({
            message: response.result_msg,
            type: 'error'
          })
        }
      })
    },
    // 赋值入网信息
    setBusinessForm (basic, pic) {
      const that = this
      that.form.merchantType = basic.fMerchantType === undefined ? '' : basic.fMerchantType
      that.form.companyChildType = basic.companyChildType === undefined ? '' : basic.companyChildType
      that.form.realMerchantType = basic.companyChildType === undefined ? that.form.merchantType : that.form.merchantType + basic.companyChildType - 1
      that.form.merchantShortName = basic.fMerchantName || ''
      that.businessForm.legalName = this.ifHide ? hideRealName(basic.fApplicant) : basic.fApplicant || ''
      that.businessForm.credentialType = basic.fCredentialType === undefined ? '' : basic.fCredentialType
      that.businessForm.idCardNo = this.ifHide && [1, 2].includes(that.businessForm.credentialType) ? hideIdCardNum(basic.fIdcard) : basic.fIdcard || ''
      that.businessForm.merchantName = basic.licenseFullName || ''
      that.businessForm.licenseType = basic.licenseType
      that.businessForm.licenseFullName = basic.fBusinessLicenseName || ''
      that.form.mccType = basic.fMccGrandpaCode
      that.form.mccMiddle = basic.fMccFatherCode
      that.form.mccCode = basic.mccCode
      // that.form.servicePhone = this.ifHide ? hidePhoneNum(basic.fServicePhone) : basic.fServicePhone || ''
      that.form.servicePhone = basic.fServicePhone || ''
      that.businessForm.license = basic.fLicense || ''
      if (!that.businessForm.license && that.form.merchantType === 1) {
        that.businessForm.licenseFlag = true
      } else {
        that.businessForm.licenseFlag = false
      }
      that.businessForm.provinceCode = basic.provinceCode
      that.businessForm.cityCode = basic.cityCode
      that.businessForm.areaCode = basic.areaCode
      that.businessForm.address = basic.fAddress || ''

      that.businessForm.idCardStart = basic.fIdcardStart
      that.businessForm.idCardEnd = basic.fIdcardEnd
      that.businessForm.licenseStart = basic.fLicenseStart
      that.businessForm.licenseEnd = basic.fLicenseEnd
      // 两个有效期赋值
      that.licenseExpiryDate.dateStart = basic.fLicenseStart
      that.licenseExpiryDate.dateEnd = ['2099-12-30', '长期', '永久', '不约定期限'].includes(basic.fLicenseEnd) ? '' : basic.fLicenseEnd
      that.licenseExpiryDate.longTermTag = ['2099-12-30', '长期', '永久', '不约定期限'].includes(basic.fLicenseEnd)

      that.idCardExpiryDate.dateStart = basic.fIdcardStart
      that.idCardExpiryDate.dateEnd = (basic.fIdcardEnd === '2099-12-30' || basic.fIdcardEnd === '长期') ? '' : basic.fIdcardEnd
      that.idCardExpiryDate.longTermTag = (basic.fIdcardEnd === '2099-12-30' || basic.fIdcardEnd === '长期')

      if (!that.readOnly) {
        that.businessForm.licensePic = pic.businessLicenseCUrl || ''
        that.businessForm.idcardFrontPic = pic.idcardFrontUrl || ''
        that.businessForm.idcardBackPic = pic.idcardBackUrl || ''
      } else {
        that.businessForm.licensePic = pic.businessLicenseC || ''
        that.businessForm.idcardFrontPic = pic.idcardFront || ''
        that.businessForm.idcardBackPic = pic.idcardBack || ''
      }
      this.needMcc = true
    },
    // 赋值结算信息
    setSettleForm (basic, pic, settleChange) {
      const that = this
      that.settleForm.accountType = basic.accountType === undefined ? '' : basic.accountType
      that.settleForm.legalFlag = basic.legalFlag === undefined ? '' : basic.legalFlag
      that.settleForm.holder = this.ifHide ? hideRealName(basic.fBankHolder) : basic.fBankHolder || ''
      that.settleForm.accountIdCardNo = this.ifHide ? hideIdCardNum(basic.bankIdCard) : basic.bankIdCard || ''
      that.settleForm.bankCardNo = this.ifHide ? hideBankCardNum(basic.fBankAccount) : basic.fBankAccount || ''
      if (basic.fBankNameCode && basic.fBankNameCode.includes('C')) {
        that.settleForm.FBankTypeCode = basic.fBankNameCode
        that.settleForm.FBankAreaCode = basic.fBankProvinceCode
        that.settleForm.FBankCityCode = basic.fBankCityCode
        that.settleForm.unionpay = basic.fUnionpayCode
      } else if (basic.fBankNameCode) {
        that.getInfoByUnion(basic.fUnionpayCode)
      }
      that.settleForm.accountMobile = this.ifHide ? hidePhoneNum(basic.fBankcardPhone) : basic.fBankcardPhone
      if (this.isEdit || settleChange) {
        that.settleForm.nonLegSettleAuthPic = pic.nonLegSettleAuthUrl || ''
        that.settleForm.nonLegIdcardFrontPic = pic.nonLegIdcardFrontUrl || ''
        that.settleForm.nonLegIdcardBackPic = pic.nonLegIdcardBackUrl || ''
        that.settleForm.bankCardFrontPic = pic.bankcardFrontUrl || ''
      } else {
        that.settleForm.nonLegSettleAuthPic = pic.nonLegSettleAuth || ''
        that.settleForm.nonLegIdcardFrontPic = pic.nonLegIdcardFront || ''
        that.settleForm.nonLegIdcardBackPic = pic.nonLegIdcardBack || ''
        that.settleForm.bankCardFrontPic = pic.bankcardFront || ''
      }
      if (that.settleForm.legalFlag === 1) {
        that.settleForm.bankIdCardType = that.businessForm.credentialType
      } else {
        that.settleForm.bankIdCardType = 1
      }
    },
    handleClick (tab) {
      this.currentTabIndex = parseInt(tab.index)
      this.activeTab = tab.name
    },
    async nextStep () {
      const validResult = this.checkFormInfo()
      if (!validResult) {
        this.$message({
          showClose: true,
          message: '请完善当前页面信息',
          type: 'error'
        })
        return
      }
      if (parseInt(this.currentTabIndex) === this.orderTabs.length - 1 && !this.readOnly) {
        await this.submit()
      }
      if (this.currentTabIndex < this.orderTabs.length - 1) {
        this.currentTabIndex++
        this.activeTab = this.orderTabs[this.currentTabIndex]
      }
    },
    lastStep () {
      if (this.submitLoading) {
        return
      }
      if (this.currentTabIndex) {
        this.currentTabIndex--
        this.activeTab = this.orderTabs[this.currentTabIndex]
      }
    },
    checkFormInfo () {
      let formValidate = false
      this.$refs[`${this.activeTab}Form`].validate((valid, error) => {
        formValidate = valid
      })
      switch (this.activeTab) {
        case 'business': {
          let addressSelectFormValid = false
          let licenseExpiryDateValid = false
          let idCardExpiryDateValid = false
          let picFormValid = false
          this.$refs.businessInfo.$refs.addressSelectForm.$refs.form.validate((valid) => {
            addressSelectFormValid = valid
          })
          this.$refs.businessInfo.$refs.licenseExpiryDate.$refs.form.validate((valid) => {
            licenseExpiryDateValid = valid
          })
          this.$refs.businessInfo.$refs.idCardExpiryDate.$refs.form.validate((valid) => {
            idCardExpiryDateValid = valid
          })
          this.$refs.businessInfo.$refs.picForm.validate((valid) => {
            picFormValid = valid
          })
          if (!addressSelectFormValid || !licenseExpiryDateValid || !idCardExpiryDateValid || !picFormValid) {
            return false
          }
          break
        }
        case 'settle': {
          let bankBranchFormValid = false
          this.$refs.settleInfo.$refs.bankBranchForm.$refs.form.validate((valid) => {
            bankBranchFormValid = valid
          })
          if (!bankBranchFormValid) {
            return false
          }
        }
      }
      if (!formValidate) {
        return false
      }
      return true
    },
    setStoreOnEvent () {
      const eventArr = ['blur', 'change', 'select']
      const self = this
      function getChildrenItem (item) {
        if (item.$el.className && !item.$el.className.includes('el-select') && !item.$el.className.includes('el-input') && !item.$el.className.includes('el-checkbox') && !item.$el.className.includes('el-autocomplete')) {
          item.$children.forEach(element => {
            getChildrenItem(element)
          })
        } else {
          eventArr.forEach(eventStr => {
            item.$on(eventStr, event => {
              self.storeToLocal()
            })
          })
        }
      }
      const refs = this.$refs
      for (const key in refs) {
        // eslint-disable-next-line no-prototype-builtins
        if (refs.hasOwnProperty(key)) {
          if (['basicForm', 'businessForm', 'settleForm', 'assistForm'].includes(key)) {
            const element = refs[key]
            getChildrenItem(element)
          }
        }
      }
    },
    /**
     * @description 本地存储方法
     * todo
     */
    storeToLocal () {
      const addInfo = {
        form: { ...this.form },
        businessForm: { ...this.businessForm },
        settleForm: { ...this.settleForm },
        picForm: { ...this.picForm },
        parentData: { ...this.parentData },
        licenseExpiryDate: { ...this.licenseExpiryDate },
        idCardExpiryDate: { ...this.idCardExpiryDate }
      }
      addInfo.form.password = ''
      localStorage.setItem('MERCHANT_ADD_INFO2', JSON.stringify(addInfo))
    },
    /**
     * @description 切换结算对象触发方法
     * @param {Number} value 0加盟分店，1总店
     */
    settleToMethod (value) {
      const that = this
      if (value === 1) {
        if (JSON.stringify(this.parentData) === '{}') {
          this.$message({
            message: '总店商户不存在或信息获取失败，请核对并重试！',
            type: 'warning'
          })
          return
        }
        const basic = this.parentData.basic
        const pic = this.parentData.pics
        this.needOcr = false
        that.setSettleForm(basic, pic, true)
        this.$nextTick(function () { that.needOcr = true })

        if (that.form.businessInfoFlag === 1) {
          that.settleForm.legalFlag = basic.legalFlag
          // 切换至法人结算时，非法人信息清空
        } else {
          that.settleForm.legalFlag = 0
        }
        // that.legalFlagDisabled = true;
      } else {
        that.$refs.settleInfo.$refs.bankBranchForm.$refs.form.resetFields()
        that.$refs.settleForm.clearValidate()
        that.settleForm.bankCardFrontPic = ''
        that.settleForm.settleTo = 0
        // 切换至法人结算时，非法人信息清空
        that.settleForm.nonLegSettleAuthPic = ''
        that.settleForm.nonLegIdcardFrontPic = ''
        that.settleForm.nonLegIdcardBackPic = ''
        that.settleForm.accountType = 1
        that.settleForm.legalFlag = ''
        that.settleForm.holder = ''
        that.settleForm.bankIdCardType = ''
        that.settleForm.accountIdCardNo = ''
        if (that.form.merchantType === 1) {
          that.settleForm.accountType = 1
          that.settleForm.legalFlag = 1
          that.settleForm.holder = that.businessForm.legalName
          that.settleForm.bankIdCardType = that.businessForm.credentialType
          that.settleForm.accountIdCardNo = that.businessForm.idCardNo
        }
      }
    },
    // 校验某个或多个字段
    checkValidate (form, fileds) {
      if (typeof fileds === 'string') {
        this.$refs[form].validateField(fileds)
      } else {
        fileds.map(filed => {
          this.$refs[form].validateField(filed)
        })
      }
    },
    setUpgrade () {
      if (!this.isUpgrade) {
        this.isUpgrade = true
        this.form.merchantType = 2
        this.form.realMerchantType = 2
        this.businessForm.licenseFlag = false
      } else {
        if (this.id !== '') {
          this.getDetailsInfo()
        }
        this.isUpgrade = false
      }
    }
  },
  provide () {
    return {
      merchantId: this.id,
      readOnly: this.readOnly,
      isEdit: this.isEdit,
      isMerchant: this.isMerchant,
      getNeedOcr: () => this.needOcr,
      form: this.form,
      businessForm: this.businessForm,
      picForm: this.picForm,
      settleForm: this.settleForm,
      parentData: this.parentData,
      licenseExpiryDate: this.licenseExpiryDate,
      idCardExpiryDate: this.idCardExpiryDate,
      getNeedMcc: () => this.needMcc,
      businessInfoMethod: this.businessInfoMethod,
      getParentData: this.getParentData,
      settleToMethod: this.settleToMethod,
      storeToLocal: this.storeToLocal,
      checkValidate: this.checkValidate,
      setUpgrade: this.setUpgrade,
      upgradeState: () => ({
        isUpgrade: this.isUpgrade,
        canUpgrade: this.canUpgrade
      })
    }
  }
}
</script>

<style scoped rel="stylesheet/scss" lang="scss">
    @mixin flex-horizontal {
        display: -webkit-box;
        display: flex;
        display: -webkit-flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
    }
    .statusDiv{
        margin: 10px 0;
    }
    .status{
        height: 30px;
        line-height: 30px;
        border-radius: 50px;
        padding: 0 15px;
        color: #fff;
        font-size: 13px;
        display: inline-block;
    }
    .status i{
        margin-right: 5px;
    }
    .status.red{
        background: #ff7070;
    }
    .status.green{
        background: #77d580;
    }
    .status.gray{
        background: #a7a7a7;
    }
    .reviewTime{
        line-height: 30px;
        height: 30px;
        display: inline-block;
        font-size: 14px;
        color: #727272;
    }
    .required {
      color: red;
    }
    .flex-center {
      display: flex;
      justify-content: center;
      align-items: center;
    }
</style>
<style>
  .el-collapse-item__arrow {
    margin: 0 8px 0 10px;
  }
  .el-collapse-item__wrap{
    border:none
  }
  .el-divider--horizontal{
    margin:10px 0
  }
</style>
